"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Color = void 0;
const index_1 = __importDefault(require("color/index"));
class Color {
    constructor(main, light, dark, background, contrastText) {
        this.main = main;
        this.light = calcLighten(main, light);
        this.dark = calcDarken(main, dark);
        this.background = calcFade(main, background);
        this.contrastText = calcContrastText(main, contrastText);
    }
    toString() {
        return this.main;
    }
    lighten(by) {
        return calcLighten(this.main, by);
    }
    atLightness(at) {
        const thing = (0, index_1.default)(this.main);
        return new Color(index_1.default.hsl([thing.hue(), thing.saturationl(), at]).toString());
    }
    darken(by) {
        return new Color((0, index_1.default)(this.main).darken(by).toString());
    }
    applyOpacity(opacity) {
        return new Color((0, index_1.default)(this.main).fade(opacity).toString());
    }
}
exports.Color = Color;
exports.default = Color;
function calcLighten(main, v = 0.2) {
    if (!!v && typeof v === 'string')
        return v;
    let c = (0, index_1.default)(main);
    return c.lightness(Math.min(c.lightness() + v * 100, 100)).string();
}
function calcDarken(main, v = 0.2) {
    if (!!v && typeof v === 'string')
        return v;
    let c = (0, index_1.default)(main);
    return c.lightness(Math.max(c.lightness() - v * 100, 0)).string();
}
function calcFade(main, v = 0.85) {
    if (!!v && typeof v === 'string')
        return v;
    let c = (0, index_1.default)(main);
    return c.fade(v).string();
}
function calcContrastText(main, v) {
    if (!!v)
        return v;
    let c = (0, index_1.default)(main);
    return c.contrast((0, index_1.default)('#1C110A')) > 12 ? '#1C110A' : '#FFFFFF';
}
